





























import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import DfMarkdownReader from '../../components/DfMarkdownReader.vue';

@Component({
    components: {
        DfMarkdownReader,
    },
})
export default class SpecialInstruction extends Vue {
    @Prop({ required: true, default: [] }) private list!: any[];

    @Prop({ required: false, default: false }) private showSpread!: boolean;

    formatTitle(title = '') {
        return title.replace(/^#*./, '').replace(/\n+$/, '');
    }

    private isSpread = false;

    private onClickSpread() {
        this.isSpread = !this.isSpread;
    }
}
